import { createSlice } from "@reduxjs/toolkit";
import * as EventApi from "../api/event";
const events = createSlice({
  name: "events",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.loading = false;
    },
    addEventSuccess: (state, action) => {
      state.list = [action.payload, ...state.list];
    },
    updateEventSuccess: (state, action) => {
      const updated =
        action.payload?.event ?? action.payload?.data ?? action.payload;
      const updatedId = updated?._id ?? updated?.id;
      if (!updatedId) return;
      state.list = state.list.map((event) => {
        const eventId = event?._id ?? event?.id;
        if (eventId === updatedId) {
          return { ...event, ...updated };
        }
        return event;
      });
    },
    deleteEventSuccess: (state, action) => {
      state.list = state.list.filter(
        (item) => action.payload?._id !== item._id
      );
    },
  },
});

export const getListEvent = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await EventApi.getListEvent(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = events;
export const {
  setLoading,
  setError,
  getListSuccess,
  addEventSuccess,
  deleteEventSuccess,
  updateEventSuccess,
} = actions;
export default reducer;
